import { EventWizard } from './EventWizard';

export default EventWizard;
